import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {PageNotFoundRoutingModule} from './page-not-found-routing.module';
import {PageNotFoundComponent} from './page-not-found.component';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
    imports: [
        PageNotFoundRoutingModule,
        //Dependencies
        CommonModule,
        TranslateModule.forChild(),
        PageNotFoundComponent
    ]
})
export class PageNotFoundModule {}
